export const environment = {
  production: true,
  API_REST_URL: 'https://api-gyg.isstec.cl/api',
  PLANTILLAS_URL: 'https://api-gyg.isstec.cl/plantillas'

};

export const API_URL = 'https://api-gyg.isstec.cl/graphql';
export const XLS_URL = 'https://api-gyg.isstec.cl/TEMP';
export const BACKWARD_YEAR_RANGE: number = 15;
export const ENVIRONMENT_FUNCTIONS = false;
